module.exports = __webpack_public_path__ + "img/Bonbon.2aff4f65.jpg";